<template>
    <div class="scans-page scrollable">
        <div class="page-header">
            <h1>Scans</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item>Scans</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="top-bar">
            <div class="count-user"></div>

            <div class="filter-user">
              <button type="button"
                      class="el-button el-button--danger"
                      @click="suspendAll">
                <span>Suspend All</span>
              </button>
            </div>

        </div>
        <div class="top-bar">
            <div class="count-scans">
                Show
                <el-select
                        v-model="countNets"
                        @change="changeCount"
                        placeholder=" "
                >
                    <el-option
                            v-for="item in countScansOptions"
                            :key="item.value"
                            :label="item.value"
                            :value="item.value"
                    >
                    </el-option>
                </el-select>
                entries
            </div>
          <div>
            <el-select v-model="reportsType" placeholder="Type of reports" @change="changeType">
              <el-option
                  v-for="item in reportTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>

          </div>
            <div class="filter-user">
                <el-input
                        @change="searchScans"
                        placeholder="Search scans"
                        v-model="filterNets"
                        prefix-icon="el-icon-search"
                ></el-input>
            </div>
        </div>

       <el-table :data="scans" @current-change="updateScanList" @sort-change="sort" @filter-change="filterChange">
        <el-table-column
            label="Id scan"
            width="100">
          <template slot="header" slot-scope="scope">
            <header-sort-title
                @sort="sort"
                title="Id Scan"
                :status-sort="sortBy"
                sort-key="id"
            />
          </template>
          <template slot-scope="scope">
            #<span style="margin-left: 3px">{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Network"
            min-width="200"
            v-if="!reportsType || reportsType == 'monthly'"
            prop="network_groups_name"
            column-key="network"
            :filters="networkGroupsFilter"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.network_groups_name }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Service Type"
            min-width="200"
            v-if="reportsType == 'locator'">
          <template slot-scope="scope">
            <span>{{ scope.row.type }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Request"
            min-width="200"
            v-if="reportsType == 'locator'">
          <template slot-scope="scope">
            <span>{{ scope.row.request }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Email"
            min-width="200"
            v-if="!reportsType || reportsType == 'monthly'">
          <template slot-scope="scope">
            <span>{{ scope.row.email }}</span>
          </template>
        </el-table-column>

         <el-table-column label="Todo List" >
           <template slot-scope="scope">
             <span v-if="scope.row.progress == 1">Added</span>
             <span v-else-if="scope.row.progress == 2">Suspended</span>
             <span v-else>Unprocessed</span>
           </template>
         </el-table-column>

         <el-table-column
             label="Status"
             column-key="percent"
             :filters="[{text:'In Progress', value:99},{text:'Finished', value:100},{text:'Not Started', value:0}]"
             prop="percent"
         >
           <template slot-scope="scope">
             <span v-if="scope.row.percent >= 1 && scope.row.percent<=99">In Progress</span>
             <span v-else-if="scope.row.percent == 0">Not Started</span>
             <span v-else>Finished</span>
           </template>
         </el-table-column>

         <el-table-column
             label="Progress"
             align="right"
         >
           <template slot-scope="scope">
             <span>{{ scope.row.percent }}%</span>
           </template>
         </el-table-column>

        <el-table-column
            label="Created at"
            align="right"
            sortable
            prop="created_at"
            sort-key="created_at"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.created_at }}</span>
          </template>
        </el-table-column>

        <el-table-column
            label="Actions"
            align="right"
            min-width="100"
        >
          <template slot-scope="scope">
            <el-button
                size="mini"
                @click="handleView(scope.row)" title="View">
              <i class="mdi mdi-eye"></i>
            </el-button>
            <el-button
                size="mini"
                @click="handleSuspend(scope.row)" title="Suspend Scan">
              <i class="mdi mdi-pause-circle"></i>
            </el-button>
            <el-button
                size="mini"
                @click="handleReload(scope.row)" title="Reload Scan">
              <i class="mdi mdi-autorenew"></i>
            </el-button>
            <el-button
                size="mini"
                @click="handleFinish(scope.row)" title="Finish Scan">
              <i class="mdi mdi-check"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>

        <div class="pagin-wrp">
            <el-pagination
                    :current-page="chosenPageFromVuex"            
                    :background="true"
                    layout="prev, pager, next"
                    :page-size="1"
                    @current-change="chosePage"
                    :total="scansMeta.last_page"
            >
            </el-pagination>
        </div>


    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import HeaderSortTitle from '../../../components/UsersList/HeaderSortTitle'
  import StatusScanChanging from "../../../components/Networks/StatusScanChanging";

  export default {
    name: 'ScansPage',
    components: {
      HeaderSortTitle,
      StatusScanChanging
    },
    data () {
      return {
        filterNets: '',
        filterBlock:{},
        countScansOptions: [
          {value: 10},
          {value: 25},
          {value: 50},
          {value: 100},
        ],
        reportTypes: [
          { value: 'monthly',
            label: 'Monthly'
          },
          { value: 'locator',
            label: 'Locator'
          },
          { value: null,
            label: 'Single report'
          },
          { value: 'tinder',
            label: 'Tinder'
          },
        ],
        sortBy: {
          id: -1,
          created_at: 0,
        },
        formatData:{
          statuses:[
            {
              id: 0,
              title: 'Not Finished'
            },
            {
              id: 1,
              title:'Finished'
            },
            {
              id: 2,
              title:'Suspended'
            }
          ]
        },

      }
    },
    computed: {
      ...mapGetters({
        scansMeta: 'scans/getScansMeta',
        networkGroupsFilter: 'networks/getNetworkGroupsFilter',
        reportsTypeFromVuex: 'networkScansFilter/getReportsType', 
        countNetsFromVuex: 'networkScansFilter/getCountNets',
        chosenPageFromVuex: 'networkScansFilter/getChosenPage',        
      }),
      chosenPage: {
          get() {
              return this.chosenPageFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkScansFilter/updateChosenPage', value);
          },
      },       
      reportsType: {
          get() {
              return this.reportsTypeFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkScansFilter/updateReportsType', value);
              this.updateScanList();
          },
      },      
      countNets: {
          get() {
              return this.countNetsFromVuex;
          },
          set(value) {
              this.$store.dispatch('networkScansFilter/updateCountNets', value);
              this.updateScanList();
          },
      },      
      scans(){
          return  this.$store.state.scans.scans
      },
      reportStatus() {
        return this.$store.state.scans.reportStatus
      },
      lastPage(){
        if(this.scans.meta){
          return this.scans.meta.last_page
        }else{
          return 1
        }
      }
    },
    created () {
      let params = 'sort=-id'
      if (this.countNets) {
        params = `${params}&per_page=${this.countNets}`
      }
      this.$store.dispatch('scans/getScans', params)
      this.$store.dispatch('networks/networkGroups')
    },
    watch:{
      filterNets(){
        this.chosenPage = 1
        this.updateScanList()
      }           
    },    
    methods: {
      filterChange(filter) {
        Object.assign(this.filterBlock, filter)
        this.updateScanList()
      },
      chosePage (e) {
        this.chosenPage = e
        this.updateScanList()
      },
      sort(by) {
        let key  = (typeof by ==="object") ? by.prop : by

        if (this.sortBy[key] === 0) {
          this.sortBy[key] = 1
        } else if (this.sortBy[key] === 1) {
          this.sortBy[key] = -1
        } else if (this.sortBy[key] === -1) {
          this.sortBy[key] = 0
        }
        if(typeof by ==="object" && by.order==null){
          this.sortBy[key] = 0
        }
        this.updateScanList()
      },

      changeCount (e) {
        this.$store.dispatch('networkScansFilter/updateCountNets', e);
        this.updateScanList()
      },
      changeType(e) {
        this.$store.dispatch('networkScansFilter/updateReportsType', e);
        this.updateScanList()
      },
      searchScans (e) {
        this.filterNets = e
        this.updateScanList()
      },
      updateScanList () {
        let params = {
          sort: ''
        };

        if (this.sortBy) {
          for (let key in this.sortBy) {
            if (this.sortBy[key] === 1) {
              params.sort += key + ',';
            } else if (this.sortBy[key] === -1) {
              params.sort += '-' + key + ',';
            }
          }
        }

        if (this.reportsType) {
          params.type = this.reportsType;
        }

        params.page = this.chosenPage;
        if (this.countNets) {
          params.per_page = this.countNets;
        }

        if (this.filterNets.length) {
          params.filter = this.filterNets;
        }

        for (let key in this.filterBlock) {
          if (this.filterBlock[key].length > 0) {
            params[key] = this.filterBlock[key];
          }
        }

        let queryString = Object.entries(params).map(([key, value]) => {
          return Array.isArray(value) ? `${key}=${JSON.stringify(value)}` : `${key}=${encodeURIComponent(value)}`;
        }).join('&');

        this.$store.dispatch('scans/getScans', queryString);
      },

      deleteScan (netData) {
        this.$store.dispatch('scans/deleteScan', netData.id)
      },
      handleEdit (index, row) {
        this.$router.push({name: 'scan-edit', params: {id: row.id}})
      },
      goToAddScan(){
        this.$router.push({name: 'scan-create'})

      },
      handleView(row){
        this.$store.dispatch('scans/getReport', row)
        this.$router.push({name: 'scan-view', params: {id: row.id}})
      },
      handleReload(row){
        this.$store.dispatch('scans/reloadScan', {id:row.id})
        this.updateScanList()
      },
      handleSuspend(row){
        this.$store.dispatch('scans/updateScan', {id:row.id, status: 2})
      },
      handleFinish(row){
        this.$store.dispatch('scans/finishScan', row.id);
      },
      suspendAll(){
        this.$confirm('This will suspend no-finished scans. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(()=> {
          this.$store.dispatch('scans/suspendUnfinishedScan').then(()=> {
          this.$store.dispatch('scans/getScans')})
        })
      },

    }

  }
</script>

<style scoped lang="scss">
    .scans-page {
          overflow-x: hidden;
    }
    th {
        .cell {
            .pointer {
                cursor: pointer;
            }
        }
    }

    .count-scans {
        width: 170px;
        margin-bottom: 25px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        & > div {
            margin: 0 5px;
        }
    }

    .filter-user {

    }
</style>
